import { Box, Collapse, Typography, IconButton, TablePagination } from '@mui/material';
import { DocumentTypeTableTitle } from '../../data/document.type.table.title';
import {
  DocumentTypeControllerAction,
  DocumentTypeControllerState,
} from '../../controller/document.type.controller';
import lineLoader from '../../../../components/lineLoader/lineLoader';
import { DocumentTypeModel } from '../../model/document.type.model';
const defaultStyle = { border: '1px solid #1A1A1A20', padding: 5, backgroundColor: '#EEEFF3' };
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../../alert/data/custom.alert.icon';
import { DocumentTypeChildrenData } from '../../data/document.type.child';
import checkAuthController from '../../../../layouts/dashboard/controllers/check-auth.controller';
import { useEffect } from 'react';
import { UserInfoModel } from '../../../user/models/user.model';
import { RoleChecker } from '../../../../utils/role-check-utils';
const CustomDocumentTypeTable = ({
  doctype,
  alert,
}: {
  doctype: DocumentTypeControllerState & DocumentTypeControllerAction;
  alert: CustomAlertState & CustomAlertAction;
}) => {
  const checkUser = checkAuthController();
  useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const user: UserInfoModel | null = checkUser.loginUser;
  return (
    <Box
      sx={{
        overflowX: 'auto',
      }}
    >
      <Collapse
        unmountOnExit={true}
        orientation={'vertical'}
        in={doctype.loading && doctype?.listCount > 0 ? true : false}
      >
        {lineLoader()}
      </Collapse>
      <Collapse
        unmountOnExit={true}
        orientation={'vertical'}
        in={doctype.loading == false || doctype?.listCount > 0 ? true : false}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {DocumentTypeTableTitle?.map((label, index) => (
                <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                  <Typography>{label.label}</Typography>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {doctype?.listDocType?.map((item: DocumentTypeModel, index: number) => (
              <tr key={index}>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{index + 1}</Typography>
                </td>

                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item?.name_en ?? '*'}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>{item?.name_la}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>
                    {doctype.listDocTypeCate.find((c) => c.uuid === item.document_type_category_id)
                      ?.name_la ?? '-'}
                  </Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Box
                    flexDirection={'row'}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    <Box
                      width={'15px'}
                      height={'15px'}
                      bgcolor={item?.color_code}
                      marginRight={'10px'}
                    />
                    <Typography>{item?.color_code}</Typography>
                  </Box>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>{item?.description}</Typography>
                </td>

                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <IconButton
                    onClick={() => {
                      doctype.onUpdateFormUpdate({
                        id: item?.uuid,
                        name_en: item.name_en,
                        name_la: item?.name_la,
                        description: item?.description,
                        color_code: item?.color_code,
                        flow_type: item.flow_type,
                        document_type_category_id: item?.document_type_category_id,
                      });
                      doctype.onHandleModal(DocumentTypeChildrenData[1]);
                    }}
                  >
                    <BorderColorIcon />
                  </IconButton>
                  <IconButton
                    disabled={RoleChecker(user) > 1}
                    onClick={() =>
                      alert.handleCustomAlert({
                        title: 'ລົບຂໍ້ມູນ',
                        message: 'ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?',
                        type: CustomAlertType.WARNING,
                        icon: CustomAlertIcons.deleteConfirm,
                        negText: 'ກັບຄືນ',
                        posText: 'ຢືນຢັນ',
                        onPositive: () => {
                          doctype.onDelete(item.uuid);
                          alert.handleCustomAlert(null);
                        },
                      })
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Collapse>
      <Box
        sx={{ display: 'flex', flexDirection: 'row', paddingRight: '20px', alignItems: 'center' }}
      >
        <Typography paddingLeft={'20px'}>ທັງໝົດ {doctype?.listCount} ລາຍການ</Typography>
        <Box sx={{ flex: 1 }} />
        <TablePagination
          component="div"
          colSpan={3}
          rowsPerPageOptions={[9, 10, 25, 50, 100]}
          count={doctype?.listCount}
          page={doctype?.page}
          onPageChange={(_, newPage) => {
            doctype?.onPageChange(newPage, doctype?.pageRowAmount);
            doctype?.docTypeGetData(true, {
              skip: doctype?.pageRowAmount * newPage,
              take: doctype?.pageRowAmount * (newPage + 1),
            });
          }}
          rowsPerPage={doctype?.pageRowAmount ?? 9}
          onRowsPerPageChange={(e) => {
            doctype?.onPageChange(0, Number.parseInt(e.target.value));
            doctype?.onFilterChange({ skip: 0, take: Number.parseInt(e.target.value) });
            doctype?.docTypeGetData(true, { skip: 0, take: Number.parseInt(e.target.value) });
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomDocumentTypeTable;
